import { render, staticRenderFns } from "./StandardSearchPageView.vue?vue&type=template&id=5987bfec&scoped=true"
import script from "./StandardSearchPageView.vue?vue&type=script&lang=js"
export * from "./StandardSearchPageView.vue?vue&type=script&lang=js"
import style0 from "./StandardSearchPageView.vue?vue&type=style&index=0&id=5987bfec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987bfec",
  null
  
)

export default component.exports